import { USERS } from '@/mocks/data/users';
import { CreativeTypeName } from '@/views/creatives/enums';
import { Creative, CreativeTemplate } from '@/views/creatives/interfaces';

export const TEMPLATES = [
  {
    id: 25,
    name: 'Option 1',
    previewUrl: 'Url1',
  },
  {
    id: 26,
    name: 'Option 2',
    previewUrl: 'Url2',
  },
  {
    id: 27,
    name: 'Option 3',
    previewUrl: 'Url3',
  },
  {
    id: 28,
    name: 'Option 4',
    previewUrl: 'Url4',
  },
  {
    id: 29,
    name: 'Option 5',
    previewUrl: 'Url5',
  },
];

export const COMPANY_TEMPLATES: Creative[] = [
  {
    id: '2iYOzfjLXJb',
    name: 'Adidas template',
    description: null,
    type: {
      id: 2,
      name: CreativeTypeName.PLAY,
      type: 'Interactive',
      isEnabled: true,
      createdAt: '2022-09-07T07:43:14.000Z',
      updatedAt: '2022-09-07T07:43:17.000Z',
    },
    coverImageS3Url: 'https://development-developmentcmpseverless-assetsbucket-1glz1lo7t2eve.s3.us-east-1.amazonaws.com/cover-images/ATtIV70kACD/awdasda_2iYOzfjLXJb_1689177646214.jpeg',
    isTemplate: true,
    creativeId: null,
    status: 'published',
    archivedAt: null,
    deletedAt: null,
    createdAt: '2022-09-16T18:20:37.000Z',
    updatedAt: '2023-07-12T15:09:42.000Z',
    isArchived: false,
    isIframed: false,
    migrationId: null,
    folderId: null,
    creator: { ...USERS.at(-1) },
  },
  {
    id: '80jmu6bkOvo',
    name: 'Alan test',
    description: null,
    type: {
      id: 2,
      name: CreativeTypeName.PLAY,
      type: 'Interactive',
      isEnabled: true,
      createdAt: '2022-09-07T07:43:14.000Z',
      updatedAt: '2022-09-07T07:43:17.000Z',
    },
    coverImageS3Url: 'https://development-developmentcmpseverless-assetsbucket-1glz1lo7t2eve.s3.us-east-1.amazonaws.com/cover-images/ATtIV70kACD/testtesty_80jmu6bkOvo_1688461245281.jpeg',
    isTemplate: true,
    creativeId: null,
    status: 'published',
    archivedAt: null,
    deletedAt: null,
    createdAt: '2023-07-04T08:21:44.000Z',
    updatedAt: '2023-07-04T08:21:44.000Z',
    isArchived: false,
    isIframed: false,
    migrationId: null,
    folderId: null,
    creator: { ...USERS[2] },
  },
];

export const CRAFTSMAN_TEMPLATES: CreativeTemplate[] = [
  {
    id: '8i3pVK4u4iy',
    name: 'Craftsman test',
    description: null,
    coverImageS3Url: 'https://development-developmentcmpseverless-assetsbucket-1glz1lo7t2eve.s3.us-east-1.amazonaws.com/cover-images/null/testtesty_8i3pVK4u4iy_1688461245120.jpeg',
    isTemplate: true,
    creativeId: null,
    status: 'published',
    archivedAt: null,
    deletedAt: null,
    createdAt: '2023-07-04T08:44:14.000Z',
    updatedAt: '2023-07-04T08:44:14.000Z',
    isArchived: false,
    isIframed: false,
    migrationId: null,
    folderId: null,
    type: {
      id: 2,
      name: CreativeTypeName.PLAY,
      type: 'Interactive',
      isEnabled: true,
      createdAt: '2022-09-07T07:43:14.000Z',
      updatedAt: '2022-09-07T07:43:17.000Z',
    },
  },
  {
    id: 'lb7yScIXbhU',
    name: 'Camilo test',
    description: null,
    coverImageS3Url: 'https://development-developmentcmpseverless-assetsbucket-1glz1lo7t2eve.s3.us-east-1.amazonaws.com/cover-images/null/testtesty_lb7yScIXbhU_1688461245247.jpeg',
    isTemplate: true,
    creativeId: null,
    status: 'published',
    archivedAt: null,
    deletedAt: null,
    createdAt: '2023-07-04T08:44:29.000Z',
    updatedAt: '2023-07-04T08:44:29.000Z',
    isArchived: false,
    isIframed: false,
    migrationId: null,
    folderId: null,
    type: {
      id: 1,
      name: CreativeTypeName.CANVAS,
      type: 'Interactive',
      isEnabled: true,
      createdAt: '2022-09-07T07:43:14.000Z',
      updatedAt: '2022-09-07T07:43:17.000Z',
    },
  },
];
